export enum ContentStyle {
  VEEQO = 'veeqo',
  SELLER_CENTRAL = 'seCe',
}
